<template>
  <div class="ctaConheca container">
    <div class="row align-items-center">
      <div class="col-12 col-lg-7">
        <div class="row">
          <div class="col-12 ctaConheca__titulo">
            <h3 class="ui-title-interna ui-title-interna--italic">Seu sonho está aqui, temos os <b class="">melhores imóveis para você!</b></h3>
          </div>
          <div class="col-12 ctaConheca__link">
            <router-link to="/empreendimentos">
              Conheça agora mesmo
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-5">
        <div class="row ctaConheca__buttons">
          <div class="col-12">
            <a data-toggle="modal" data-target="#ModalEmail">
              <button class="ui-button ui-button--transparent w-100">Envie-nos um e-mail</button>
            </a>
          </div>
          <div class="col-12">
            <a data-toggle="modal" data-target="#ModalLigamos">
              <button class="ui-button w-100">Ligamos para você</button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- modal E-mail -->
    <div class="modal fade" id="ModalEmail" tabindex="-1" role="dialog" aria-labelledby="ModalEmailLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Envie-nos um <b>e-mail</b>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitFormEmail" class="w-100 text-right">
              <input type="text" v-model="form.name" class="ui-input ui-input--green" placeholder="Nome" required>
              <input type="email" v-model="form.email" class="ui-input ui-input--green" placeholder="E-mail" required>
              <textarea class="ui-input ui-input--green" v-model="form.description" rows="7" placeholder="Mensagem" required></textarea>
              <button class="ui-button" type="submit" :disabled="disabled">
                {{submitButton}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- modal E-mail fim -->
    <!-- modal Ligamos -->
    <div class="modal fade" id="ModalLigamos" tabindex="-1" role="dialog" aria-labelledby="ModalLigamosLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Ligamos para <b>você</b>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitFormContact" class="w-100 text-right">
              <input type="text" v-model="contact.name" class="ui-input ui-input--green" placeholder="Nome" required>
              <input type="email" v-model="contact.email" class="ui-input ui-input--green" placeholder="E-mail" required>
              <the-mask class="ui-input ui-input--green" v-model="contact.phone" placeholder="Telefone" required :mask="['(##) ####-####', '(##) #####-####']" />
              <button class="ui-button" type="submit" :disabled="disabled">
                {{submitButton}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- modal LIgamos fim -->
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
export default {
  props: ['business'],
  components: {
    TheMask
  },
  data () {
    return {
      update: false,
      disabled: false,
      submitButton: 'Enviar',
      form: {
        name: '',
        email: '',
        description: '',
        title: this.business.title
      },
      contact: {
        name: '',
        email: '',
        phone: '',
        title: this.business.title
      }
    }
  },
  computed: {
    ...mapGetters(['contactSend'])
  },
  methods: {
    submitFormEmail () {
      this.disabled = true
      this.submitButton = 'Enviando'
      let content = {
        'destiny': 'faleconosco.comcasa@gmail.com',
        'originName': 'Website Comcasa',
        'title': 'Interesse em empreendimento',
        'message': `Uma pessoa entrou em contato referente ao empreendimento ${this.form.title}:<br><br>Nome: ${this.form.name}<br>E-mail: ${this.form.email}<br>Mensagem: ${this.form.description}`
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.form})
          swal(
            'Enviado :)',
            'E-mail enviado com sucesso.',
            'success'
          )
          this.form = {
            name: '',
            email: '',
            description: '',
            title: this.business.title
          }
          this.disabled = false
          this.submitButton = 'Enviar'
        })
    },
    submitFormContact () {
      this.disabled = true
      this.submitButton = 'Enviando'
      let content = {
        'destiny': 'faleconosco.comcasa@gmail.com',
        'originName': 'Website Comcasa',
        'title': 'Interesse em contato',
        'message': `Uma nova pessoa quer que entrem em contato com ela referente ao empreendimento ${this.form.title}:<br><br>Nome: ${this.contact.name}<br>E-mail: ${this.contact.email}<br>Telefone: ${this.contact.phone}`
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.contact})
          swal(
            'Enviado :)',
            'E-mail enviado com sucesso.',
            'success'
          )
          this.contact = {
            name: '',
            email: '',
            phone: '',
            title: this.business.title
          }
          this.disabled = false
          this.submitButton = 'Enviar'
        })
    }
  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables.scss';

.ctaConheca{
  padding-top: 6.5em;
  padding-bottom: 7em;
  @media (max-width: 1600px) {
    padding-top: 4em;
    padding-bottom: 4.5em;
  }
  @media (max-width: 1024px) {
    padding-top: 3em;
    padding-bottom: 3.5em;
  }
  @media (max-width: 575px) {
    padding-top: 3.5em;
    padding-bottom: 2.5em;
  }
  &__titulo{
    h3{
      font-weight: 300;
      margin-bottom: 2.25em;
      @media (max-width: 992px) {
        text-align: center;
        margin-bottom: 0.75em;
      }
      b{
        font-style: italic;
        font-weight: 700;
        line-height: 70px;
        @media (max-width: 575px) {
          line-height: 26px;
        }
      }
      @media (max-width: 575px) {
        line-height: 26px;
      }
    }
  }
  &__link{
    @media (max-width: 992px) {
      text-align: center;
      margin-bottom: 2em;
    }
    a{
      padding-left: 7.5em;
      font-size: 18px;
      position: relative;
      transition: all 0.2s;
      @media (max-width: 375px) {
        padding-left: 15px;
        text-decoration: underline $green solid!important;
        padding-bottom: 5px;
      }
      &:hover{
        color: $green;
        transition: all 0.2s;
      }
      &:before{
        content: '';
        position: absolute;
        background-color: $green;
        width: 100px;
        height: 5px;
        left: 0px;
        top: 45%;
        @media (max-width: 375px) {
          display: none;
        }
      }
    }
  }
  &__buttons{
    .ui-button--transparent{
      color: $text;
      margin-bottom: 20px;
    }
    button{
      padding: 13px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CtaConheca.vue